import { type BadgeColor, StatusBadge } from '@civilgrid/ui/components';
import type { Agency } from '~/common/types';

const SOURCE_CONFIG: Record<string, { label: string; color: BadgeColor; title: string; description: string }> = {
  sharableRoutes: {
    label: 'Fiber Line',
    color: 'blue',
    title: 'Discovered via Connectbase Fiber Line',
    description: 'A Connectbase fiber route crosses or runs near the project area.',
  },
  networkIntelligence: {
    label: 'Fiberlit Building',
    color: 'yellow',
    title: 'Discovered via Connectbase Fiberlit Building',
    description:
      'Provider serves fiber-lit building(s) near the project area. This does not imply a fiber line under the dig site — but per policy these agencies are still requested.',
  },
};

const INFERRED_NOTE = ' Label inferred from stored geometry (predates source tracking).';

export default function DiscoverySourceBadges({
  agency,
}: {
  agency: Pick<Agency, 'discoverySources' | 'discoverySourcesInferred'>;
}) {
  const sources = agency.discoverySources;
  if (!sources?.length) return null;
  return (
    <span className="flex flex-row items-center gap-1" data-testid="discovery-source-badges">
      {sources.map((source) => {
        const cfg = SOURCE_CONFIG[source];
        if (!cfg) return null;
        return (
          <span key={source} data-testid={`discovery-source-badge-${source}`}>
            <StatusBadge
              color={cfg.color}
              data-testid={`discovery-source-badge-button-${source}`}
              tooltip={{
                title: cfg.title,
                description: agency.discoverySourcesInferred ? cfg.description + INFERRED_NOTE : cfg.description,
              }}
            >
              {cfg.label}
            </StatusBadge>
          </span>
        );
      })}
    </span>
  );
}
